<main *ngIf="!error; else errorMsg" class="container">
    <div *ngIf="area">
        <h2 class="title">{{ area.nome }}</h2>
        <div style="display: flex">
            <div style="width: 48px; height: auto;"></div>
            <button class="btn-area rounded-pill btn-lg btn-primary" (click)="showAreasTecnologicas()">Áreas
                Tecnológicas
            </button>
            <div style="width: 48px; height: auto;"></div>
        </div>
    </div>
    <section class="response">
        <p *ngIf="totalResultados" class="text-center results">
            Total de resultados encontrados {{ totalResultados }}
        </p>
        <p *ngIf="!totalResultados" class="text-center results">
            Desculpe, não encontramos nenhum resultado compatível com a busca.
        </p>
        <ul>
            <li class="card bg-color-white contrast-border" *ngFor="let curso of cursos">
                <app-card [titulo]="curso.nome" [texto]="curso.perfilProfissional" [id]="curso.id"
                    [tipo]="curso.tipo"></app-card>
            </li>
        </ul>
        <ng-container *ngIf="totalResultados > 0">
            <app-paginacao [paginaAtual]="paginaAtual" [totalPaginas]="totalPaginas"
                (mudouPagina)="onPaginaSelecionada($event)"></app-paginacao>
        </ng-container>
    </section>
</main>
<ng-template #errorMsg> </ng-template>